import { HttpErrorResponse } from "@angular/common/http";
import { AbstractControl } from "@angular/forms";
import { EMAIL_DOMAIN_KEY } from "../interfaces/api-error";

/** The error a control carries once the API refused its address for having no mail server. */
export const EMAIL_DOMAIN_ERROR = "emailDomain";

/**
 * Puts the API's refusal of an address with no mail server on the email field, next to the toast
 * the interceptor already shows. The error goes away as soon as the user edits the address.
 *
 * @returns whether the error was the API's email domain refusal
 */
export function markEmailDomainError(error: unknown, control: AbstractControl | null | undefined): boolean {
	if (!(error instanceof HttpErrorResponse) || error.error?.key !== EMAIL_DOMAIN_KEY || !control) {
		return false;
	}
	control.setErrors({ ...(control.errors ?? {}), [EMAIL_DOMAIN_ERROR]: true });
	control.markAsTouched();
	return true;
}
